import { Controller } from "@hotwired/stimulus"

// A burst of confetti when a payment lands: pieces of paper fall from the top
// of the viewport, spin and fade, then remove themselves. Pure DOM and the
// Web Animations API, no library. Skipped for people who ask for less motion.
const COLORS = ["#ff5b1f", "#22c55e", "#3b82f6", "#facc15", "#ec4899", "#f4f0ea"]

export default class extends Controller {
  static values = { pieces: { type: Number, default: 140 } }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.layer = document.createElement("div")
    this.layer.setAttribute("aria-hidden", "true")
    this.layer.style.cssText = "position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:50"
    document.body.appendChild(this.layer)

    const animations = Array.from({ length: this.piecesValue }, () => this.drop())

    Promise.all(animations.map((animation) => animation.finished)).then(() => this.layer?.remove())
  }

  disconnect() {
    this.layer?.remove()
  }

  drop() {
    const piece = document.createElement("span")
    const size = 6 + Math.random() * 8
    const left = Math.random() * 100
    const drift = (Math.random() - 0.5) * 300
    const spin = (Math.random() - 0.5) * 1440

    piece.style.cssText = `position:absolute;top:-20px;left:${left}vw;width:${size}px;height:${size * 0.45}px;` +
      `background:${COLORS[Math.floor(Math.random() * COLORS.length)]};border-radius:2px;opacity:0.95`
    this.layer.appendChild(piece)

    return piece.animate(
      [
        { transform: "translate3d(0, 0, 0) rotate(0deg)", opacity: 1 },
        { transform: `translate3d(${drift}px, 105vh, 0) rotate(${spin}deg)`, opacity: 0.85 },
      ],
      { duration: 2200 + Math.random() * 1800, delay: Math.random() * 500, easing: "cubic-bezier(0.2, 0.6, 0.4, 1)", fill: "forwards" },
    )
  }
}
